export default __webpack_public_path__ + "static/tge-ddca52ee9cc0e1e769f7baef5dda982c.jpg";